import { Box, Flex, Text } from "flicket-ui";
import { Event } from "~graphql/sdk";
import { FormatDate } from "@flicket/utils";
import { useContext } from "react";
import { BaseContext } from "~context";

export const MenuEventHeader = ({ event }: { event: Event }) => {
  const { organization } = useContext(BaseContext);
  return (
    <Box
      display={{ _: "flex", md: "none" }}
      position="absolute"
      bottom="16px"
      left="16px"
      zIndex={2}
      maxW="calc(100% - 32px)"
      flexDir="column"
    >
      <Text
        fontSize={6}
        lineHeight="medium"
        fontWeight="heavy"
        color="white"
        mb="1/2"
        ellipsis
      >
        {event.title}
      </Text>
      <Flex
        mr={{ _: 2, md: 4 }}
        flexDir="column"
        minW={{ _: "80px", md: "auto" }}
      >
        <Text fontSize={1} lineHeight="normal" mb="1/4" color="white">
          {FormatDate.eventDate(
            event.startDate as string,
            event.endDate as string,
            "short",
            {
              // TODO: this is implemented before date work is complete.
              // Replace with event timezone and locale.
              timezone: organization.timezone,
              locale: "en-NZ",
            }
          )}
        </Text>
      </Flex>
      <Text fontSize={1} lineHeight="normal" color="white">
        {event.venue?.name}, {event.venue?.address?.city}
      </Text>
    </Box>
  );
};
